import MediumHeader from "../UI/textFields/MediumHeader";
import StandardButton from "../UI/buttons/StandardButton";
import labels from "../../utils/labels";
import dateUtil from "../../utils/dateUtil";
import { NexusImportWarning } from "../../hooks/WebSocketProvider";

/**
 * Tells the user what the backend changed in the data imported from Nexus. Only OK closes it (not Escape or a
 * click outside), so the change can't be missed.
 */
const ImportValidationWarningDialog = ({
  warnings,
  onAcknowledge,
}: {
  warnings: NexusImportWarning[];
  onAcknowledge: () => void;
}) => {
  const trimmedShifts = warnings.filter(
    (warning) => warning.code === "SHIFT_TRIMMED_TO_PLANNING_DAY",
  );

  return (
    <div className="ImportValidationWarningDialog fixed inset-0 bg-black/50 flex items-center justify-center z-[1000]">
      <div
        role="alertdialog"
        aria-modal="true"
        aria-label={labels.importValidationWarningHeader}
        className="bg-white rounded-lg shadow-lg p-6 w-[620px]"
      >
        <MediumHeader classes={"pb-2"}>
          {labels.importValidationWarningHeader}
        </MediumHeader>
        {trimmedShifts.length > 0 && (
          <>
            <p className={"bodyTwo pb-4"}>
              {labels.importValidationWarningShiftTrimmedIntro}
            </p>
            <ul className="flex flex-col gap-2 pb-4 max-h-[50vh] overflow-y-auto">
              {trimmedShifts.map(({ subject, details }) => (
                <li
                  key={details.shiftId}
                  className="border rounded-lg p-3 bodyTwo"
                >
                  <p className="font-bold pb-1">{subject}</p>
                  <div className="grid grid-cols-[auto_1fr] gap-x-4">
                    <span>{labels.importValidationWarningNexusWorkTime}</span>
                    <span>
                      {`${dateUtil.formatDateTime(details.originalStart)} – ${dateUtil.formatDateTime(details.originalEnd)}`}
                    </span>
                    <span className="col-span-2 italic">
                      {labels.importValidationWarningAdjustedTo}
                    </span>
                    <span>{labels.importValidationWarningPondooWorkTime}</span>
                    <span className="font-bold">
                      {`${dateUtil.formatClockTime(details.adjustedStart)} – ${dateUtil.formatClockTime(details.adjustedEnd)}`}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </>
        )}
        <div className={"flex flex-row justify-end"}>
          <StandardButton
            variant={"PRIMARY"}
            onClick={onAcknowledge}
            ariaLabel={labels.importValidationWarningOk}
          >
            {labels.importValidationWarningOk}
          </StandardButton>
        </div>
      </div>
    </div>
  );
};

export default ImportValidationWarningDialog;
